import React, { lazy } from 'react';
import { Route } from 'react-router';
import Authenticated from '../../components/auth/Authenticated';
import routes from '../routes';

const AssessmentQuestionsListScreen = lazy(() => import('../../screens/AssessmentQuestions/screens/List'));
const AssessmentQuestionsEditScreen = lazy(() => import('../../screens/AssessmentQuestions/screens/Edit'));

const AssessmentQuestionsRoutes = [
    <Route
        exact
        key={routes.ASSESSMENT_QUESTIONS_LIST}
        path={routes.ASSESSMENT_QUESTIONS_LIST}
        render={() => (
            <Authenticated>
                <AssessmentQuestionsListScreen />
            </Authenticated>
        )}
    />,

    <Route
        exact
        key={routes.ASSESSMENT_QUESTIONS_EDIT}
        path={routes.ASSESSMENT_QUESTIONS_EDIT}
        render={() => (
            <Authenticated redirectTo={routes.HOME}>
                <AssessmentQuestionsEditScreen />
            </Authenticated>
        )}
    />,
];

export default AssessmentQuestionsRoutes;
